import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const INITIAL_STATE = {
  _id: null,
  status: "draft",
  selection: {
    where: {
      north: false,
      south: false,
      east: false,
      west: false,
      "central-east": false,
      "central-west": false,
      "south-east": false,
      "south-west": false,
    },
    when: {
      date: moment().add(7, "days").toDate(),
      startTime: "19:00",
      endTime: "22:00",
    },
    what: [], //Array of objects [{ activity: "eat",selections:["carribean",indian] }]
    anything: {
      noOfPeople: 2,
      vibe: [],
      accessibility: [],
      fromLondon: [],
      notes: null,
    },
    budget: "50",
    additional3Surprises: false,
    acceptedTerms: false,
    discountCode: null,
    isCorporate: false,
  },
  stripe: {
    paymentIntent: null,
  },
};

export const booking = createSlice({
  name: "booking",
  initialState: INITIAL_STATE,
  reducers: {
    setBooking: (state, action) => {
      console.log("setBooking");
      state = action.payload;
      if (!state.selection) {
        state.selection = INITIAL_STATE.selection;
      }
      console.log("state", state);
      return state;
    },
    setSelection: (state, action) => {
      state.selection = action.payload;
      return state;
    },
    setSelectionFor: (state, action) => {
      const { key, value } = action.payload;
      state.selection[key] = value;
      console.log("redux set selection for", key, value, state.selection[key]);
      return state;
    },
    clearSelection: (state) => {
      state.selection = INITIAL_STATE.selection;
      return state;
    },
    clearBooking: (state) => {
      state = INITIAL_STATE;
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSelection,
  setSelectionFor,
  clearSelection,
  setBooking,
  clearBooking,
} = booking.actions;

export default booking.reducer;
